<template>
  <!-- 热门话题 -->
  <div class="cdethottopic">
    <div class="zjbthea between">
      <div>热门话题</div>
      <div class="mo">更多></div>
    </div>
    <div class="topiclist">
      <div class="topicitem flex_start" v-for="item in 5" :key="item">
        <div class="topicicon">
          <img src="../../../assets/zx_consult/hottopicicon.png" alt="" />
        </div>
        <div class="qtm">
          <div class="qtmname ellipsis">离婚后探视权怎么规定的？</div>
          <div class="qtmlab flex_start">
            <div>探视权</div>
            <div class="ml20">2020.04.30 16:12</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scope>
.cdethottopic {
  width: 100%;
  padding: 10px 10px 0;
  .zjbthea {
    padding: 14px 20px 14px 10px;
    font-size: 18px;
    color: #333333;
    .mo {
      font-size: 14px;
      color: #999999;
      cursor: pointer;
    }
  }
  .topiclist {
    padding: 0 10px;
    .topicitem {
      align-items: flex-start;
      padding: 18px 0;
      border-top: 1px solid #eee;
      cursor: pointer;
      .topicicon {
        width: 18px;
        margin-right: 5px;
        img {
          width: 18px;
          height: 18px;
          vertical-align: top;
        }
      }
      .qtm {
        .qtmname {
          width: 240px;
          font-size: 14px;
          color: #333333;
        }
        .qtmlab {
          margin-top: 12px;
          font-size: 12px;
          color: #bbbbbb;
        }
      }
    }
  }
}
</style>